
import 'unfetch/polyfill';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, sortBy } from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import {
  translate as t,
  FieldTitle,
} from 'admin-on-rest';

const headers = new Headers();
headers.append('Accept', 'application/json');

const request = new Request(process.env.REACT_APP_RESTAURANT_API_URL, {
  method: 'GET',
  headers,
});

export class SelectInput extends Component {
  state = {
    value: this.props.input.value,
    choices: [],
  };

  componentWillMount = async () => {
    const response = await fetch(request);
    const choices = await response.json();
    return this.setState({ choices: sortBy(choices, 'CountryCode').map((choice) => ({ id: `${choice.ID}`, name: `${choice.ID} | ${choice.CountryCode}-${choice.City}-${choice.Street}` })) });
    // return this.setState({ choices: [{ id: 3, 'name' te }] });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      this.setState({ value: nextProps.input.value });
    }
  }

  handleChange = (event, index, value) => {
    this.props.input.onChange(value);
    return this.setState({ value });
  };

  addAllowEmpty = (choices) => {
    if (this.props.allowEmpty) {
      return [
        <MenuItem value={null} key="null" primaryText="" />,
        ...choices,
      ];
    }

    return choices;
  };

  renderMenuItem = (choice) => {
    const {
      optionText,
      optionValue,
      translate,
      translateChoice,
    } = this.props;
    const choiceName = React.isValidElement(optionText) // eslint-disable-line no-nested-ternary
      ? React.cloneElement(optionText, { record: choice })
      : typeof optionText === 'function'
        ? optionText(choice)
        : get(choice, optionText);
    return (
      <MenuItem
        key={get(choice, optionValue)}
        primaryText={
          translateChoice ? (
            translate(choiceName, { _: choiceName })
          ) : (
            choiceName
          )
        }
        value={get(choice, optionValue)}
      />
    );
  };

  render() {
    const {
      elStyle,
      isRequired,
      label,
      meta,
      options,
      resource,
      source,
    } = this.props;
    if (typeof meta === 'undefined') {
      throw new Error(
        "The SelectInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const { touched, error } = meta;
    const { choices } = this.state;

    return (
      <SelectField
        value={this.state.value}
        floatingLabelText={
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        }
        onChange={this.handleChange}
        autoWidth
        style={elStyle}
        errorText={touched && error}
        {...options}
      >
        {this.addAllowEmpty(choices.map(this.renderMenuItem))}
      </SelectField>
    );
  }
}

SelectInput.propTypes = {
  addField: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  optionText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]),
  optionValue: PropTypes.string,
  resource: PropTypes.string,
  source: PropTypes.string,
  translate: PropTypes.func.isRequired,
  translateChoice: PropTypes.bool,
};

SelectInput.defaultProps = {
  addField: true,
  allowEmpty: true,
  options: {},
  optionText: 'name',
  optionValue: 'id',
  translateChoice: true,
};

export default connect()(t(SelectInput));
